import { createSlice } from "@reduxjs/toolkit";

const normalizeProductsByCategoryPayload = (payload) => {
  const products = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.products)
      ? payload.products
      : Array.isArray(payload)
        ? payload
        : [];

  if (payload && typeof payload === "object" && !Array.isArray(payload)) {
    return {
      ...payload,
      data: products,
      products,
    };
  }

  return {
    success: true,
    data: products,
    products,
  };
};

const Homesclice = createSlice({
  name: "home",
  initialState: {
    Cartloading: false,
    Cartdata: null,
    Carterror: null,

    getCartLoading: false,
    getCartdata: null,
    getCarterror: null,

    removecartLoading: false,
    removecart: null,
    removecartError: null,

    getHomeproductdataLoading: false,
    getHomeproductdata: null,
    getHomeproductdataError: null,

    getsimilarproductdataLoading: false,
    getsimilarproductdata: null,
    getsimilarproductdataError: null,

    getproductbycategoryidLoading: false,
    getproductbycategoryiddata: null,
    getproductbycategoryiderror: null,

    addwishlistLoading: false,
    addwishlistdata: null,
    addwishlisterror: null,

    removewishlistLoading: false,
    removewishlistdata: null,
    removewishlisterror: null,


    getproductbyidLoading: false,
    getproductbyiddata: null,
    getproductbyiderror: null,


    getcategorywithsubcategoryLoading: false,
    getcategorywithsubcategorydata: null,
    getcategorywithsubcategoryerror: null,


    getproductwithbrandLoading: false,
    getproductwithbranddata: null,
    getproductwithbranderror: null,

    getsubcategorywithproductLoading: false,
    getsubcategorywithproductdata: null,
    getsubcategorywithproducterror: null,

    banners: [],
    topBanners: [],
    smallBanners: [],
    smallBanner: null,
    bottomBanners: [],
    loading: false,
    error: null,
  },
  reducers: {
    insertCartRequest: (state) => {
      state.Cartloading = true;
      state.Carterror = null;
    },
    insertCartSuccess: (state, action) => {
      state.Cartloading = false;
      state.Cartdata = action.payload;
    },
    insertCartFailure: (state, action) => {
      state.Cartloading = false;
      state.Carterror = action.payload;
    },
    getCartRequest: (state) => {
      state.getCartLoading = true;
      state.getCarterror = null;
    },
    getCartSuccess: (state, action) => {
      state.getCartLoading = false;
      state.getCartdata = action.payload;
    },
    getCartFailure: (state, action) => {
      state.getCartLoading = false;
      state.getCarterror = action.payload;
    },
    removeCartRequest: (state) => {
      state.removecartLoading = true;
      state.removecartError = null;
    },
    removeCartSuccess: (state, action) => {
      state.removecartLoading = false;
      state.removecart = action.payload;
    },
    removeCartFailure: (state, action) => {
      state.removecartLoading = false;
      state.removecartError = action.payload;
    },
    getHomeproductdataRequest: (state) => {
      state.getHomeproductdataLoading = true;
      state.getHomeproductdataError = null;
    },
    getHomeproductdataSuccess: (state, action) => {
      state.getHomeproductdataLoading = false;
      state.getHomeproductdata = action.payload;
    },
    getHomeproductdataFailure: (state, action) => {
      state.getHomeproductdataLoading = false;
      state.getHomeproductdataError = action.payload;
    },
    getsimilarproductdataRequest: (state) => {
      state.getsimilarproductdataLoading = true;
      state.getsimilarproductdataError = null;
    },
    getsimilarproductdataSuccess: (state, action) => {
      state.getsimilarproductdataLoading = false;
      state.getsimilarproductdata = action.payload;
    },
    getsimilarproductdataFailure: (state, action) => {
      state.getsimilarproductdataLoading = false;
      state.getsimilarproductdataError = action.payload;
    },

    getproductbycategoryidRequest: (state) => {
      state.getproductbycategoryidLoading = true;
      state.getproductbycategoryidError = null;
    },
    getproductbycategoryidSuccess: (state, action) => {
      state.getproductbycategoryidLoading = false;
      state.getproductbycategoryiddata = normalizeProductsByCategoryPayload(
        action.payload
      );
    },
    getproductbycategoryidFailure: (state, action) => {
      state.getproductbycategoryidLoading = false;
      state.getproductbycategoryidError = action.payload;
    },
    addwishlistrequest: (state) => {
      state.addwishlistLoading = true;
      state.addwishlisterror = null;
    },
    addwishlistsuccess: (state, action) => {
      state.addwishlistLoading = false;
      state.addwishlistdata = action.payload;
    },
    addwishlistfailure: (state, action) => {
      state.addwishlistLoading = false;
      state.addwishlisterror = action.payload;
    },
    removewishlistrequest: (state) => {
      state.removewishlistLoading = true;
      state.removewishlisterror = null;
    },
    removewishlistsuccess: (state, action) => {
      state.removewishlistLoading = false;
      state.removewishlistdata = action.payload;
    },
    removewishlistfailure: (state, action) => {
      state.removewishlistLoading = false;
      state.removewishlisterror = action.payload;
    },
    getproductbyidRequest: (state) => {
      state.getproductbyidLoading = true;
      state.getproductbyiderror = null;
    },
    getproductbyidSuccess: (state, action) => {
      state.getproductbyidLoading = false;
      state.getproductbyiddata = action.payload;
    },
    getproductbyidFailure: (state, action) => {
      state.getproductbyidLoading = false;
      state.getproductbyiderror = action.payload;
    },
    getcategorywithsubcategoryRequest: (state) => {
      state.getcategorywithsubcategoryLoading = true;
      state.getcategorywithsubcategoryerror = null;
    },
    getcategorywithsubcategorySuccess: (state, action) => {
      state.getcategorywithsubcategoryLoading = false;
      state.getcategorywithsubcategorydata = action.payload;
    },
    getcategorywithsubcategoryFailure: (state, action) => {
      state.getcategorywithsubcategoryLoading = false;
      state.getcategorywithsubcategoryerror = action.payload;
    },
    getproductwithbrandRequest: (state) => {
      state.getproductwithbrandLoading = true;
      state.getproductwithbranderror = null;
    },
    getproductwithbrandSuccess: (state, action) => {
      state.getproductwithbrandLoading = false;
      state.getproductwithbranddata = action.payload;
    },
    getproductwithbrandFailure: (state, action) => {
      state.getproductwithbrandLoading = false;
      state.getproductwithbranderror = action.payload;
    },
    getsubcategorywithproductRequest: (state) => {
      state.getsubcategorywithproductLoading = true;
      state.getsubcategorywithproducterror = null;
    },
    getsubcategorywithproductSuccess: (state, action) => {
      state.getsubcategorywithproductLoading = false;
      state.getsubcategorywithproductdata = action.payload;
    },
    getsubcategorywithproductFailure: (state, action) => {
      state.getsubcategorywithproductLoading = false;
      state.getsubcategorywithproducterror = action.payload;
    },
    getBannersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBannersSuccess: (state, action) => {
      state.loading = false;
      state.banners = action.payload?.banners || [];
      state.topBanners = action.payload?.topBanners || [];
      state.smallBanners = action.payload?.smallBanners || [];
      state.smallBanner = action.payload?.smallBanner || null;
      state.bottomBanners = action.payload?.bottomBanners || [];
    },
    getBannersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  insertCartRequest,
  insertCartSuccess,
  insertCartFailure,
  getCartRequest,
  getCartSuccess,
  getCartFailure,
  removeCartRequest,
  removeCartFailure,
  removeCartSuccess,
  getHomeproductdataRequest,
  getHomeproductdataSuccess,
  getHomeproductdataFailure,
  getsimilarproductdataRequest,
  getsimilarproductdataSuccess,
  getsimilarproductdataFailure,
  getproductbycategoryidRequest,
  getproductbycategoryidSuccess,
  getproductbycategoryidFailure,
  addwishlistrequest,
  addwishlistsuccess,
  addwishlistfailure,
  removewishlistrequest,
  removewishlistsuccess,
  removewishlistfailure,
  getproductbyidRequest,
  getproductbyidSuccess,
  getproductbyidFailure,
  getcategorywithsubcategoryRequest,
  getcategorywithsubcategorySuccess,
  getcategorywithsubcategoryFailure,
  getproductwithbrandRequest,
  getproductwithbrandSuccess,
  getproductwithbrandFailure,
  getsubcategorywithproductRequest,
  getsubcategorywithproductSuccess,
  getsubcategorywithproductFailure,
  getBannersRequest,
  getBannersSuccess,
  getBannersFailure,
} = Homesclice.actions;

export default Homesclice.reducer;
